// Formato para password 

import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  CardActions,
  Typography,
  TextField,
  Stack,
} from "@mui/material";
import { validateField, passwordValidator, requiredValidator } from "../validators";
import { apiFetch } from '../fetchWrapper';

export default function PasswordForm({ user, onSave }) {
  if (!user) return null;

  const emptyForm = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const [form, setForm] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedForm = {
      ...form,
      [name]: value,
    };

    setForm(updatedForm);

    setErrors((prev) => {
      const next = { ...prev };
      let error = null;

      if (name === "confirmPassword" || name === "newPassword") {
        error = validateField(value, [
          requiredValidator,
          passwordValidator,
        ]);
      }

      if (error) {
        next[name] = error;
      } else {
        delete next[name];
      }

      const newPass = updatedForm.newPassword;
      const confirmPass = updatedForm.confirmPassword;

      if (newPass && confirmPass) {
        if (newPass !== confirmPass) {
          next.confirmPassword = "Las contraseñas no coinciden";
        } else {
          delete next.confirmPassword;
        }
      }

      return next;
    });
  };

  const handleCancel = () => {
    setForm(emptyForm);
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await apiFetch(`/api/users/${user.id}/change-password`, {
        method: "POST",
        body: JSON.stringify({
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        }),
      }).then((res) => {
        if (!res.ok) {
          throw new Error("Error al cambiar la contraseña");
        }
      });
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
      setForm(emptyForm);
      setErrors({});
      onSave(user);
    }
  };

  const hasErrors = Object.keys(errors).length > 0;
  const requiredFieldsFilled =
    form.currentPassword && form.newPassword && form.confirmPassword;

  return (
    <Card sx={{ maxWidth: 600, margin: "2rem auto", p: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Cambiar contraseña
        </Typography>

        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="Contraseña actual"
              name="currentPassword"
              type="password"
              value={form.currentPassword}
              onChange={handleChange}
              error={!!errors.currentPassword}
              helperText={errors.currentPassword}
              slotProps={{ htmlInput: { maxLength: 15 } }}
              fullWidth
              required
            />

            <Typography variant="p" sx={{
              mb: 2, fontSize: "0.75rem",
              color: "primary.main"
            }}
            >
              La contraseña debe contener:
              <br />- Entre 8 y 15 caracteres
              <br />- Al menos una letra mayúscula
              <br />- Al menos un número

            </Typography>

            <TextField
              label="Nueva contraseña"
              name="newPassword"
              type="password"
              value={form.newPassword}
              onChange={handleChange}
              error={!!errors.newPassword}
              helperText={errors.newPassword}
              slotProps={{ htmlInput: { maxLength: 15 } }}
              fullWidth
              required
            />

            <TextField
              label="Confirmar contraseña"
              name="confirmPassword"
              type="password"
              value={form.confirmPassword}
              onChange={handleChange}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
              slotProps={{ htmlInput: { maxLength: 15 } }}
              fullWidth
              required
            />

            <CardActions sx={{ justifyContent: "flex-end", px: 0 }}>
              <Button
                type="button"
                variant="contained"
                color="error"
                onClick={handleCancel}
                disabled={saving}
              >
                Cancelar
              </Button>

              <Button
                type="submit"
                variant="contained"
                disabled={saving || hasErrors || !requiredFieldsFilled}
              >
                {saving ? "Guardando…" : "Guardar"}
              </Button>
            </CardActions>
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
}